import React from "react";

import { toLocaleStringFormatter } from "../../utils/utils";

const MoneyCard = ({ img, title, text }) => {
  return (
    <div className=" p-3 flex gap-3 bg-neutral-20 shadow-lg rounded-lg items-center w-full col-span-1  ">
      <img className="p-1 rounded-v-lg w-10 h-10 hidden md:block" src={img} alt="check" />
      <div className="text-gray-500 flex flex-col gap-2">
        <p className="text-[12px] text-neutral-40 font-semibold">{title}(ریال)</p>
        <p className="text-[16px] text-dark font-semibold">{text ? toLocaleStringFormatter(text) : 0} </p>
      </div>
    </div>
  );
};

export default MoneyCard;
